import React from "react";

const publicModules = [
    {
        name: "Artificial Intelligence",
        category: "Intelligent Logistics",
        technology: "AI / ML",
        description:
            "Prediction, anomaly detection and intelligent decision support for logistics operations.",
    },
    {
        name: "IoT Monitoring",
        category: "Telemetry",
        technology: "IoT",
        description:
            "Integration of logistics devices, sensors and shipment telemetry.",
    },
    {
        name: "Blockchain Verification",
        category: "Data Integrity",
        technology: "Blockchain",
        description:
            "Immutable audit and verification of logistics operations.",
    },
    {
        name: "Digital Twin",
        category: "Logistics Monitoring",
        technology: "Digital Twin",
        description:
            "Virtual representation and monitoring of logistics processes and shipments.",
    },
    {
        name: "Identity-Based Security",
        category: "Security",
        technology: "ASP.NET Core",
        description:
            "Authentication, authorization and secure data exchange for platform users.",
    },
    {
        name: "Logistics Management",
        category: "Operations",
        technology: "ASP.NET Core / SQL Server",
        description:
            "Management of shipments, warehouses and logistics operations.",
    },
];

const PlatformModulesPage = () => {
    return (
        <div className="min-h-screen bg-slate-950 text-white px-8 py-12">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold mb-4">
                    Platform Architecture
                </h1>

                <p className="text-slate-300 max-w-5xl mb-10">
                    IDLogicChain is designed as an extensible intelligent logistics
                    platform integrating Artificial Intelligence, IoT telemetry,
                    blockchain verification, Digital Twin technologies and secure
                    logistics services.
                </p>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {publicModules.map((module) => (
                        <div
                            key={module.name}
                            className="bg-slate-900 border border-slate-800 rounded-xl p-6"
                        >
                            <h2 className="text-xl font-bold mb-3">
                                {module.name}
                            </h2>

                            <p className="text-blue-300 text-sm mb-2">
                                {module.category}
                            </p>

                            <p className="text-slate-400 text-sm mb-3">
                                {module.technology}
                            </p>

                            <p className="text-slate-300">
                                {module.description}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 border-t border-slate-800 pt-8">
                    <p className="text-slate-400">
                        The platform follows a modular architecture that allows
                        additional logistics and technology components to be
                        integrated as the system evolves.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PlatformModulesPage;